/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { subscriptionStore } from '../../axios/subscriptionStore'
import type {
	SubscriptionStoreError,
	SubscriptionStorePathParams,
	SubscriptionStoreRequest,
	SubscriptionStoreResponse,
} from '../../types/SubscriptionStore'

export const subscriptionStoreMutationKey = () => [{ url: '/:organisation/profiles/:profile/subscription' }] as const

export type SubscriptionStoreMutationKey = ReturnType<typeof subscriptionStoreMutationKey>

export type SubscriptionStoreVariables = {
	organisation: SubscriptionStorePathParams['organisation']
	profile: SubscriptionStorePathParams['profile']
	data: SubscriptionStoreRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::store */
export function useSubscriptionStore<TContext = unknown>(
	options?: UseMutationOptions<
		SubscriptionStoreResponse,
		AxiosError<SubscriptionStoreError>,
		SubscriptionStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: subscriptionStoreMutationKey(),
		mutationFn: ({ organisation, profile, data }: SubscriptionStoreVariables) =>
			subscriptionStore(organisation, profile, data, config).then(res => res.data),
		...options,
	})
}
